<!--
 * @Author: ken yang
 * @Date: 2022-09-02 16:54:48
 * @LastEditTime: 2023-03-08 14:19:03
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_admin/src/App.vue
-->
<template>
  <div class="trade-style-a min-W">
    <el-config-provider :locale="locale">
      <router-view v-slot="{ Component }">
        <!-- <keep-alive> -->
        <Component :is="Component" />
        <!-- </keep-alive> -->
      </router-view>
    </el-config-provider>
  </div>
</template>

<script setup>
// import zh from 'element-plus/lib/locale/lang/zh-cn'
const configStore = useConfigStore()
const userStore = useUserStore()

if (!localStorage.token) {
  router.push('/Login')
} else {
  userStore.userInfo()
}

let locale = $ref()

const setLocale = async () => {
  const zh_cn = LANGCN
  const us_en = LANGEN
  const zh_tw = LANGTW
  const ja_jp = LANGJA
  const langMap = {
    [zh_cn]: import('element-plus/dist/locale/zh-cn.mjs'),
    [us_en]: import('element-plus/dist/locale/en.mjs'),
    [zh_tw]: import('element-plus/dist/locale/zh-tw.mjs'),
    [ja_jp]: import('element-plus/dist/locale/ja.mjs'),
  }
  locale = (await langMap[configStore.locale]).default
}

onMounted(() => {
  console.log('当前环境', import.meta.env)
  setTimeout(() => {
    replaceParamVal('token', '')
  }, 1000)
})

onBeforeMount(async () => {
  setLocale()
})

// 登录以后自动跳转到home
// const autoJump = () => {
//   if (jumpPaths.includes(route.path) && userStore.token) {
//     const redirectUrl = route.query?.redirect
//     if (redirectUrl) {
//       router.push(decodeURIComponent(redirectUrl))
//     } else {
//       router.push('/home')
//     }
//   }
// }

watch(
  () => userStore.token,
  async () => {
    if (userStore.token) {
      localStorage.token = userStore.token
      userApi.userInfo({})
    } else {
      router.push('/login')
    }
  }, {
    immediate: true
  }
)

watch(
  () => configStore.locale,
  async (path) => {
    await setLocale()
  }
)
</script>

<style lang="scss">
@use "sass:math";
@use "sass:map";
@import "@/sass/index.scss";

html,
body,
#app {
  margin: 0;
  padding: 0;
}
th {
  font-weight: 400;
}
.group-2JyOhh7Z- {
  background-color: transparent !important;
}

html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $font-color;

}
</style>
